
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((130|760|878)9|1791|2878|3754|5470|6061|6510|8213)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
